import { render, staticRenderFns } from "./AdvertisePage.vue?vue&type=template&id=6cc12c98&scoped=true&"
import script from "./AdvertisePage.vue?vue&type=script&lang=ts&"
export * from "./AdvertisePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc12c98",
  null
  
)

export default component.exports